// seller-service endpoint paths (relative to VITE_SELLER_API_URL). The service
// mounts under the `/api` global prefix. Referenced via this constant so a path
// change is a single edit — never hard-coded at call sites. Per-resource paths
// are builder functions so the id is interpolated in one place.
export const listingRequestEndpointPaths = {
  LISTING_REQUESTS: '/api/listing-requests',
  listingRequest: (id: string) => `/api/listing-requests/${id}`,
  listingRequestTimeline: (id: string) => `/api/listing-requests/${id}/timeline`,
  listingRequestAgreements: (id: string) => `/api/listing-requests/${id}/agreements`,
  // Phase B seller actions.
  listingRequestPriceResponse: (id: string) => `/api/listing-requests/${id}/price-response`,
  listingRequestWithdraw: (id: string) => `/api/listing-requests/${id}/withdraw`,
  // UAE Pass agreement signing (per agreement + signatory).
  agreementSignInitiate: (id: string, agreementId: string, signatoryId: string) =>
    `/api/listing-requests/${id}/agreements/${agreementId}/signatories/${signatoryId}/sign`,
  agreementShareLink: (id: string, agreementId: string, signatoryId: string) =>
    `/api/listing-requests/${id}/agreements/${agreementId}/signatories/${signatoryId}/share-link`,
  agreementSignComplete: (id: string, agreementId: string, signatoryId: string) =>
    `/api/listing-requests/${id}/agreements/${agreementId}/signatories/${signatoryId}/sign/complete`,
  agreementSignDecline: (id: string, agreementId: string, signatoryId: string) =>
    `/api/listing-requests/${id}/agreements/${agreementId}/signatories/${signatoryId}/decline`,
} as const
